/**
 * The shape guards the four statement views validate their payloads with.
 *
 * They exist for one reason, and it is not typing: this workspace mounts no error boundary, so a
 * reshaped or nullable field reaching a render path throws and replaces the whole Finance route
 * with the router's default error screen, instead of the view's own tested error state. Each guard
 * checks the fields its view actually reads, and the view treats a failure as a load error.
 */

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isNumberArray(value: unknown): value is number[] {
  return Array.isArray(value) && value.every((entry) => typeof entry === 'number');
}

export function isNullableNumberArray(value: unknown): value is (number | null)[] {
  return (
    Array.isArray(value) && value.every((entry) => entry === null || typeof entry === 'number')
  );
}

export function isNullableString(value: unknown): value is string | null {
  return value === null || typeof value === 'string';
}

export function isNullableNumber(value: unknown): value is number | null {
  return value === null || typeof value === 'number';
}
